/** @module csi/widget/icon/Util */
define([
	"csi/_base/underscore",
	"csi/html",
	"csi/widget/CustomIconWithLabel",
	"csi/widget/MaterialIconWithLabel",
	"csi/xml",
], function(_,html,CustomIconWithLabel,MaterialIconWithLabel,xml) {

	const CSS_ICON_BACKGROUND_COLOR = "csi-icon-bg-color-";
	const CSS_ICON_BLOCK = "csi-icon-block";
	const CSS_ICON_COLOR = "csi-icon-color-";
	
	/**
	 * The map from value of item icon enum to icon class
	 */
	const iconsForItem = {
		1: "check_circle",
		2: "check_circle_outline",
		4: "undo",
		5: "replay",
		6: "not_interested",
		7: "highlight_off",
		8: "cancel"
	};
	
	const customIconsForItem = {
		3: "submit-"
	};

	/**
	 * The map from value of item enum to color class
	 */
	const colorsForItem = {
		1: "red",
		2: "grey",
		3: "green",
		4: "orange",
		5: "lightgreen"
	};

	/**
	 * Return the color based on the enum passed in
	 * @param {enum} enumItem
	 * @return {string}
	 */
	function getActionColor(enumItem) {
		const enumValue = xml.enumGetText(enumItem);
		return colorsForItem[enumValue] || "";
	}
	
	/**
	 * Create HTML string for span
	 * @param {string} css
	 * @param {string} [text]
	 * @return {string}
	 */
	function getLabelSpan(css, text) {
		return "<span class='" + html.inlineCss(css) + "'>" + (text || "") + "</span>";
	}
	
	/**
	 * Return css for react rendering for the color based on the enum passed in
	 * @param {string} enumItem
	 * @return {string}
	 */
	function getTaskActionColorCSS(enumItem) {
		const colorClassName = getActionColor(enumItem);
		return CSS_ICON_BLOCK + (colorClassName ? (" " + CSS_ICON_BACKGROUND_COLOR + colorClassName) : "");
	}

	/**
	 * Return HTML for the color based on the enum passed in
	 * @param {string} enumItem
	 * @return {string}
	 */
	function getTaskActionColorHtml(enumItem) {
		const css = getTaskActionColorCSS(enumItem);
		return css ? getLabelSpan(css) : "";
	}

	/**
	 * Return Css for the icon based on the enum passed in
	 * @param {enum} enumItem
	 * @param {enum} colorEnumItem - in the case of combination, represent the color enum
	 * @return {string}
	 */
	function getTaskActionIconCss(enumItem, colorEnumItem) {
		const enumValue = xml.enumGetText(enumItem);

		if (!enumValue) {
			return "";
		}
		
		const color = getActionColor(colorEnumItem);
		const customIcon = customIconsForItem[enumValue];
		const materialIcon = iconsForItem[enumValue];
		const widgetClass = materialIcon ? MaterialIconWithLabel : CustomIconWithLabel;
		let icon;
		let iconCss;

		if (customIcon) {
			icon = customIcon + (color || "grey");
		} else {
			icon = materialIcon;

			if (color) {
				iconCss = CSS_ICON_COLOR + color;
			} else {
				iconCss = "csi-camunda-action-icon";
			}
		}
		return {icon, iconCss, widgetClass}
	}

	/**
	 * Return HTML for the icon based on the enum passed in
	 * @param {enum} enumItem
	 * @param {enum} colorEnumItem - in the case of combination, represent the color enum
	 * @param {string} [label] - optional label to append after icon
	 * @return {string}
	 */
	function getTaskActionIconHtml(enumItem, colorEnumItem, label) {
		const actionIconCss = getTaskActionIconCss(enumItem, colorEnumItem)
		if (!actionIconCss) {
			return "";
		}
		const {icon, iconCss, widgetClass} = actionIconCss;

		return widgetClass.getIconHtml({
			icon,
			iconCss: iconCss || "",
			inline: true,
			label: label || ""
		});
	}

	return {
		getTaskActionIconCss,
		getTaskActionColorHtml,
		getTaskActionColorCSS,
		getTaskActionIconHtml
	};
});
